import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import RatingModal from '../components/modal/Rating';
import axios from '../api/axios';
import { isAxiosError } from 'axios'; 
import BottomNav from "../components/BottomNav"; 

import Notification from "../components/modal/Notification";

import DoctorBusy from "../components/modal/DoctorBussy";
import { zim } from '../zegoConfig';
import { generateToken } from '../components/utils/tokenUtils';

import '@fortawesome/fontawesome-free/css/all.min.css';
import Service from "../components/modal/Service";
import DoctorCard from "../components/card/DoctorCard";
import SpecialistCard from "../components/card/SpecialistCard";
import ConsultationCard from "../components/card/ConsultationCard";
import { stat } from "fs";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const [homeData, setHomeData] = React.useState<any>(null);
  const [practitioner_role_id, setPractitionerRoleId] = useState<string | null>(null);
  const [isModalOpen, setModalOpen] = useState(false); 
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalAppointment, setShowModalAppointment] = useState<boolean>(false);
  const [isDeliveryModalOpen, setDeliveryModalOpen] = useState(false);
  const [showService, setShowService] = useState(false);
  const [doctorData, setDoctorData] = useState<any[]>([]);
  const [specialistData, setSpecialistData] = useState<any[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<any | null>(null);

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 4 && hour < 12) {
      return { color: 'morning', text: 'Selamat Pagi', image: 'morning' };
    } else if (hour >= 12 && hour < 17) {
      return { color: 'afternoon', text: 'Selamat Siang', image: 'afternoon' };
    } else if (hour >= 17 && hour < 18) {
      return { color: 'evening', text: 'Selamat Sore', image: 'afternoon' };
    } else {
      return {
        color: 'evening',
        text: 'Selamat Malam',
        image: 'morning',
        style: {
          background: 'linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(14,24,34,1) 35%, rgba(29,88,122,1) 100%)'
        }
      };
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`home`, {
          params: {
            user_id: userData?.id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        const data = response.data.data;
        console.log(data, "data");
        setHomeData(data);

      } catch (error) {
        if (isAxiosError(error)) {
          if (error.response?.status === 404 || error.response?.status === 400) {
            navigate('/not-found');
          }
        } else {
          console.error('Unexpected error:', error);
        }
      }
    };
    
    fetchData(); // Selalu fetch saat Home dirender
  }, [token]);

  useEffect(() => {
    const fetchDataPractitionerRoleId = async () => {
      try {
        const response = await axios.get(`teleconsultation`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        setPractitionerRoleId(response.data.id);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchDataPractitionerRoleId(); // Selalu fetch saat Home dirender
  }, [token]);

  useEffect(() => {
    const fetchPractitioner = async () => {
      try {
        const response = await axios.get(`practitoner-roles`, {
          headers: {  
            Authorization: `Bearer ${token}`,
          },
          params: {
            origin: 'homepage'
          }
        });
        const practitioner = response.data.data;
        const practitionerDoctors = practitioner.map((item:any, index:any) => ({
          practitioner_role_id: item.id, 
          name: `dr. ${item.name}`,
          specialization: item.speciality_name || 'Umum',
          years: parseInt(item.year_experience, 10),
          rating: Math.round((item.rating || 0) * 20), // convert 0–5 to 0–100 scale
          hospital: item.hospital_name?.replace(/\r?\n|\r/g, '').trim() || '',
          price: item.price_chat,
          photoUrl: item.avatar_url || `https://i.pravatar.cc/150?img=${index + 1}`,
          is_online: item.is_online || false,
        }));
        setDoctorData(practitionerDoctors);

      } catch (error) {
        console.error('Error fetching practitioner:', error);
      }
    }

    fetchPractitioner()
  }, [token]);

  useEffect(() => {
    const fetchSpecialists = async () => {
      try {
        const response = await axios.get('specialities', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            status: 'active'
          }
        });

        // Ambil data dari response
        const specialistsData = response.data;

        // Mapping sesuai kebutuhan
        const formattedSpecialists = specialistsData.map((item: any) => ({
          id: item.id,
          name: item.name,
          iconUrl: item.image_url || '/app-icons/specialist/umum.svg',
        }));

        setSpecialistData(formattedSpecialists);
      } catch (error) {
        console.error('Error fetching specialists:', error);
      }
    };

    fetchSpecialists();
  }, [token]);


  const handleOnClickLivechat = () => {
    if (homeData?.teleconsult) {
      const status = homeData.teleconsult.status;
      const teleconsultId = homeData.teleconsult.id;

      if (status === "ongoing") {
        navigate(`/chat/${teleconsultId}`);
      } 
      // else if (status === "resolve_by_doctor") {
      //   // tampilkan popup
      //   setShowModal(true);
      // }
      else {
        navigate(`/list-doctor`, {
          state: { filters: { schedule: 1 } }
        });
      }
    } else {
      navigate(`/list-doctor`, {
          state: { filters: { schedule: 1 } }
      });
    }
  }

  const handleSpecialistClick = (id: number) => {
    navigate('/list-doctor', {
      state: { filters: { speciality_id: id } }
    });
  };


  const greeting = getGreeting();
  return (
    <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#D8F3F7", minHeight: "100vh", paddingBottom: "60px", // Tambahkan ini
      }}>
      {/* Header + Greeting Section */}
        <div className="flex flex-wrap justify-center">
          {/* Bagian Kiri */}
          <div className="flex flex-col items-center p-8 pb-0 bg-morning-300 flex-1 w-full md:w-1/2 sm:flex-initial">
            <h2
              className="mb-4 text-xl text-white lg:mb-2 sm:text-2xl md:sm:text-xl"
              style={greeting.style ? { ...greeting.style } : {}}
            >
              {greeting.text}, {userData ? userData.person.name : ""}!
            </h2>
            <img
              className="w-auto mx-auto lazy mb-4"
              src={greeting.image === "morning" ? userData?.image_morning_greeting  : userData?.image_afternoon_greeting}
              alt="Good Selamat Pagi"
            />
          </div>

          {/* Bagian Kanan */}
          <div className="flex flex-row flex-wrap w-full md:mt-0 md:w-1/2">
          
          {/* Livechat */}
          <div className="flex w-1/2 py-12 md:py-0 flex-col bg-morning-200 justify-center text-center">
            {(!practitioner_role_id || practitioner_role_id === 'null') ? (
              <>
                <DoctorBusy isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
                <div
                  className="loader_overlay cursor-pointer"
                  onClick={() => setModalOpen(true)}
                >
                  <div className="mb-3">
                    <img
                      className="w-auto h-16 mx-auto lazy"
                      src="https://m.linksehat.com/assets/img/icons/ask-doctor-white.png"
                      alt="Konsultasi Sekarang"
                    />
                  </div>
                  <h2 className="text-sm font-medium text-white sm:text-lg md:text-sm">
                    Livechat
                  </h2>
                </div>
              </>
            ) : (
              <div
                id="liveChatLink"
                className="loader_overlay cursor-pointer"
                onClick={handleOnClickLivechat}
              >
                <div className="mb-3">
                  <img
                    className="w-auto h-16 mx-auto lazy"
                    src="https://m.linksehat.com/assets/img/icons/ask-doctor-white.png"
                    alt="Konsultasi Sekarang"
                  />
                </div>
                <h2 className="text-sm font-medium text-white sm:text-lg md:text-sm">
                  Livechat
                </h2>
              </div>
            )}
          </div>


          {/* E-Prescription */}
            <div className="relative flex w-1/2 py-12 md:py-0 flex-col bg-morning justify-center text-center">
              <div
                id="ePrescriptionLink"
                className="loader_overlay cursor-pointer"
                onClick={() => navigate('/e-prescription')}
              >
                <div className="mb-3">
                  <img
                    className="w-auto h-16 mx-auto lazy"
                    src="https://m.linksehat.com/assets/img/icons/article-white.png"
                    alt="Info Kesehatan"
                  />
                  {homeData && homeData.prescription_count > 0 ? (
                    <div id="nilai_total_belum_download">
                      <span className="absolute top-2 right-2 block w-5 h-5 bg-red-600 text-white text-xs rounded-full flex items-center justify-center -mt-2 -mr-2">
                        {homeData.prescription_count}
                      </span>
                    </div>
                  ) : null  }
                  
                </div>
                <h2 className="text-sm font-medium text-white sm:text-lg md:text-sm">
                  E-Prescription
                </h2>

              </div>
            </div>
          </div>
        </div>
        
        {/* Rating Section */}
         {homeData && homeData.doctor_review ? (() => {
          const dateObj = new Date(homeData.doctor_review.date_consultation);
          const day = String(dateObj.getDate()).padStart(2, '0');
          const month = dateObj.toLocaleString('id-ID', { month: 'long' });
          const dayName = dateObj.toLocaleString('id-ID', { weekday: 'long' });
          const doctorName = homeData.doctor_review.doctor_name || 'Dokter';

          return (
            <div
              style={{
                padding: "20px",
                backgroundColor: "#ffffff",
                marginTop: "-10px",
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
              }}
            >
              <h3 style={{ textAlign: "center", color: "#007E7A", fontWeight: "bold", textTransform: "uppercase" }}>
                RATING TELEKONSULTASI
              </h3>

              <div
                onClick={() => setDeliveryModalOpen(true)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  textDecoration: "none",
                  overflow: "hidden",
                  cursor: "pointer"
                }}
              >
                <div style={{ backgroundColor: "#007E7A", width: "100%", textAlign: "center", color: "#fff" }}>
                  <div style={{ backgroundColor: "#007E7A", padding: "10px", fontWeight: "bold", textTransform: 'capitalize' }}>
                    {month}
                  </div>
                  <div style={{ backgroundColor: "#fff", color: "#007E7A", fontSize: "36px", fontWeight: "bold", paddingTop: "5px" }}>
                    {day}
                  </div>
                  <div style={{ backgroundColor: "#fff", color: "#007E7A", fontSize: "14px", paddingBottom: "10px", textTransform: 'capitalize' }}>
                    {dayName}
                  </div>
                </div>

                <div style={{ padding: "15px", backgroundColor: "#fff" }}>
                  <div style={{ fontSize: "14px", fontWeight: "500", color: "#007E7A", textAlign: "center" }}>
                    Rate Telekonsultasi Sekarang bersama
                  </div>
                  <div style={{ fontSize: "20px", fontWeight: "bold", color: "#333", marginTop: "10px", textAlign: "center" }}>
                    {doctorName}
                  </div>
                  <div className="flex flex-col flex-wrap items-center justify-center w-full px-2 py-4 bg-white rounded-r-lg">
                    <span className="text-center en-chat">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fa fa-star fa-3x animated pulse infinite"></i>
                      ))}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })() : null}
        
      {/* Notification Section */}

    <div className="max-w-md mx-auto px-4 pt-6 mb-2 bg-gray-100">
      {/* Consultation Schedule Card */}
      {homeData?.teleconsult && ['ongoing', 'upcoming'].includes(homeData.teleconsult.status) && (() => {
        const teleconsult = homeData.teleconsult;
        const dateObj = new Date(teleconsult.date_consultation);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = dateObj.toLocaleString('id-ID', { month: 'long' });
        const dayName = dateObj.toLocaleString('id-ID', { weekday: 'long' });
        const formattedDate = `${dayName}, ${day} ${month} ${dateObj.getFullYear()}`;
        const doctorName = teleconsult.doctor_name || 'Dokter';
        const photoUrl = teleconsult.doctor_avatar_url || 'https://i.pravatar.cc/100?img=2';

        const handleClick = () => {
          if (teleconsult.status === 'ongoing') {
            navigate(`/chat/${teleconsult.id}`);
          } else if (teleconsult.status === 'upcoming') {
            setShowModalAppointment(true);
          }
        };

        return (
          <div onClick={handleClick} style={{ cursor: teleconsult.status === 'ongoing' ? 'pointer' : 'default' }}>
            <ConsultationCard
              doctorName={`dr. ${doctorName}`}
              date={formattedDate}
              time={teleconsult.time_consultation}
              photoUrl={photoUrl}
            />
          </div>
        );
      })()}

      {/* Tanya Dokter Kami */}
        <div className="flex items-center justify-between  mb-2">
          <h3 className="text-md font-semibold mt-4 mb-2">Tanya Dokter Kami</h3>
          <button className="text-morning-300 text-sm font-medium" onClick={() => navigate('/list-doctor')}>Lihat Semua</button>
        </div>
        {doctorData.map((doc, index) => (
          <div key={index} className="mb-4">
            <DoctorCard 
              doctor={doc} 
              onConsult={() => {
                setSelectedDoctor(doc); 
                setShowService(true)
              }}
            />
          </div>
        ))}

      {/* Specialist */}
      <div className="max-w-md mx-auto px-1 py-4 bg-gray-100">
        <h3 className="text-md font-semibold mb-4">Spesialis</h3>
        <div className="grid grid-cols-3 gap-4">
          {specialistData.map((item, index) => (
            <SpecialistCard 
              key={index} 
              name={item.name} 
              iconUrl={item.iconUrl} 
              onClick={() => handleSpecialistClick(item.id)}
            />
          ))}
        </div>
      </div>
      
      </div>


      {/* MODALS */}
      <Notification
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Mohon maaf untuk saat ini livechat dibatasi sehari sekali"
      />

      <Notification
        show={showModalAppointment}
        onClose={() => setShowModalAppointment(false)}
        message="Konsultasi akan dimulai pada waktu yang telah dijadwalkan. Silakan tunggu hingga waktu tersebut"
      />

      <RatingModal
        isOpen={isDeliveryModalOpen}
        onClose={() => setDeliveryModalOpen(false)}
        doctorId={homeData?.doctor_review?.doctor_id || '0'}
        teleconsultId={homeData?.doctor_review?.teleconsult_id || '0'}
        patientId={userData?.person?.id || '0'}
      />

      <Service
        isOpen={showService}
        onClose={() => setShowService(false)}
        onSubmit={(data) => {
          setShowService(false);
          if (homeData?.teleconsult?.status === 'ongoing') {
            navigate(`/chat/${homeData?.teleconsult?.id}`);
          } else {
            if (data.waktu === 'sekarang') {
              navigate(`/disclaimer/${selectedDoctor?.practitioner_role_id}`);
            } else {
              navigate(`/schedule-consultation/${selectedDoctor?.name}`, {
              state: { doctor: selectedDoctor },
            });
          }
          }
        }}
        isOnline={selectedDoctor?.is_online || false}
      />

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default Home;
